/**
 * SCAPI Shopper Search lexical `q` (and suggestions / custom content `c_q`) max length.
 * Platform lexical search rejects longer phrases with a string-length constraint error.
 */
export const SEARCH_QUERY_MAX_LENGTH = 50;
